export default __webpack_public_path__ + "static/media/photo--lg--misc-24.da5981a5.jpg";